
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'AgeLimit18'
})
export default class AgeLimit18 extends Vue {}
